module.exports = __webpack_public_path__ + "img/K6.7296ef3a.png";